export class PreparingStatusDeleteRequest {
  ideaId!: string
  resolutionPreparingStatusId!: string

  constructor(ideaId: string, resolutionPreparingStatusId: string) {
    this.ideaId = ideaId
    this.resolutionPreparingStatusId = resolutionPreparingStatusId
  }
}
